export default __webpack_public_path__ + "static/media/iso.335e78c9.svg";